export const UPDATE_FONDO       = 'UPDATE_FONDO';
export const UPDATE_CODICE_ISIN = 'UPDATE_CODICE_ISIN';
export const UPDATE_NOME_FONDO  = 'UPDATE_NOME_FONDO';